module.exports = __webpack_public_path__ + "static/media/jest-logo.c7c07500.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/expect-more/assets/jest-logo.png
// module id = 240
// module chunks = 0